export default __webpack_public_path__ + "static/media/cdmb.ac397945.png";